export default {"src":"/_next/static/media/wrong-position-3-sitter.29a3f065.svg","height":61,"width":80,"blurWidth":0,"blurHeight":0};